import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { apiClient } from '@/lib/api-client'

function AuthCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    // Handle GitHub connection callback (not a login)
    const connectionProvider = searchParams.get('connection')
    if (connectionProvider) {
      const returnUrl = localStorage.getItem('auth_return_url')
      if (returnUrl) {
        localStorage.removeItem('auth_return_url')
        window.location.href = returnUrl
      } else {
        window.location.href = '/settings'
      }
      return
    }

    const accessToken = searchParams.get('access_token')
    const refreshToken = searchParams.get('refresh_token')

    if (accessToken && refreshToken) {
      // Store tokens with underscores (as expected by AuthContext)
      localStorage.setItem('access_token', accessToken)
      localStorage.setItem('refresh_token', refreshToken)

      // Set the access token in the API client
      apiClient.setAccessToken(accessToken)

      // Check for saved return URL (e.g., from expired GitHub token flow)
      const returnUrl = localStorage.getItem('auth_return_url')
      if (returnUrl) {
        localStorage.removeItem('auth_return_url')
        window.location.href = returnUrl
      } else {
        // Default redirect to overview
        window.location.href = '/overview'
      }
    } else {
      // No tokens, redirect to login
      navigate('/login', { replace: true })
    }
  }, [searchParams, navigate])

  return (
    <main className="flex min-h-[calc(100vh-4.5rem)] items-center justify-center px-4">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">Completing authentication...</h2>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
      </div>
    </main>
  )
}

export default AuthCallbackPage
